// extracted by mini-css-extract-plugin
export default {"wrapper":"deleteCard_wrapper__EPVJt","button_wrapper":"deleteCard_button_wrapper__CCW5A","btn":"deleteCard_btn__MrG7+"};